import type { StateMachineMetadata } from '@percent/admin-dashboard/api/actions/grantProgram/grantProgram.types'

export const mockStateMachineMetadata: StateMachineMetadata = {
  eventNames: [
    { value: 'EVENT_NOMINATION_SUBMITTED', label: 'Nomination Submitted' },
    { value: 'EVENT_CANDIDATE_ORGANISATION_ATTACHED', label: 'Organisation Attached' },
    { value: 'EVENT_CANDIDATE_ORGANISATION_REJECTED', label: 'Organisation Rejected' },
    { value: 'EVENT_CANDIDATE_PASSED_VERIFICATION', label: 'Passed Verification' },
    { value: 'EVENT_CANDIDATE_FAILED_VERIFICATION', label: 'Failed Verification' },
    { value: 'EVENT_CANDIDATE_TASK_COMPLETED', label: 'Task Completed' },
    { value: 'EVENT_CANDIDATE_NONPROFIT_CLAIM_APPROVED', label: 'Nonprofit Claim Approved' },
    { value: 'EVENT_CANDIDATE_NONPROFIT_CLAIM_REJECTED', label: 'Nonprofit Claim Rejected' },
    { value: 'EVENT_CANDIDATE_ORG_CONTACT_SIGNED_UP', label: 'Org Contact Signed Up' },
    { value: 'EVENT_CANDIDATE_NONPROFIT_ONBOARDING_EMAIL_SENT', label: 'Nonprofit Onboarding Email Sent' },
    { value: 'EVENT_CANDIDATE_REJECTED_BY_ADMIN', label: 'Rejected By Admin' },
    { value: 'EVENT_CANDIDATE_DONATION_PAID', label: 'Donation Paid' },
    { value: 'EVENT_CANDIDATE_DONATION_PROCESSING', label: 'Donation Processing' },
    { value: 'EVENT_CANDIDATE_EMAIL_SENT', label: 'Email Sent' }
  ],
  emailTemplates: [
    'NominationReceipt',
    'ApplicationReceipt',
    'TaskReminderEmail',
    'ApplicationRejection',
    'NonprofitOnboarding',
    'NonprofitOnboardingRegionalPhilanthropy',
    'AwardLetter',
    'AwardNominator',
    'ActionAwardNominator',
    'PaymentConfirmation',
    'TwilioOnboarding'
  ],
  slackTemplates: ['PassToDueDiligenceStage'],
  taskTemplates: [
    { id: '1', name: 'Task template 1' },
    { id: '2', name: 'Task template 2' }
  ],
  displayModes: ['hidden', 'enabled', 'disabled'],
  tableTypes: ['task', 'task_with_score', 'multiple_tasks', 'rejected', 'status', 'disbursement'],
  comparisonOperators: ['==', '!=', '>', '>=', '<', '<='],
  logicalOperators: ['and', 'or'],
  eventPayloadFields: {
    EVENT_CANDIDATE_TASK_COMPLETED: [
      { field: 'taskTemplateId', type: 'string' },
      { field: 'completedBy', type: 'string' }
    ],
    EVENT_CANDIDATE_DONATION_PAID: [
      { field: 'amount', type: 'number' },
      { field: 'currency', type: 'string' }
    ]
  },
  v2: {
    conditionTypes: ['set', 'numeric'],
    matchModes: ['any', 'all'],
    organisationConditionFields: ['country', 'activityTags', 'orgType', 'id']
  }
}
